import React from "react";
import SEO from "../components/SEO";
import { ShieldCheck } from "lucide-react";

const Security = () => (
  <div className="relative min-h-screen bg-[#0B0F19] text-white">
    <SEO title="Security - QryptShield" />
    <div className="absolute inset-0 z-0 pointer-events-none">
      <div
        className="absolute inset-0 opacity-[0.08]"
        style={{
          backgroundImage:
            "linear-gradient(to right, #ffffff60 1px, transparent 1px), linear-gradient(to bottom, #ffffff60 1px, transparent 1px)",
          backgroundSize: "40px 40px",
        }}
      />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[900px] h-[450px] bg-blue-600/20 rounded-[100%] blur-[120px]" />
    </div>

    <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16 space-y-10">
      <div className="space-y-3 text-center mt-12">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-500/10 border border-blue-500/20 text-blue-300 text-xs font-semibold">
          <ShieldCheck className="w-4 h-4" /> Security Overview
        </div>
        <h1 className="text-4xl font-bold">Built for Post-Quantum Security</h1>
        <p className="text-gray-400 max-w-3xl mx-auto">
          QryptShield pairs post-quantum cryptography with rigorous operational
          security to safeguard remote access.
        </p>
      </div>

      <div className="bg-white/5 border border-white/10 rounded-2xl p-8 space-y-6 shadow-xl">
        {[
          {
            title: "Cryptography",
            body: "Hybrid PQC with classical ECDH + NIST-approved Kyber/Dilithium for forward secrecy and signatures.",
          },
          {
            title: "Transport Security",
            body: "TLS 1.3 everywhere, strict cipher suites, HSTS, and certificate pinning in clients where supported.",
          },
          {
            title: "Identity & Access",
            body: "MFA for admins, least privilege, audit logs, and scoped tokens for automation.",
          },
          {
            title: "Monitoring & Response",
            body: "24/7 monitoring, anomaly detection, and an incident response runbook with rapid key rotation.",
          },
          {
            title: "Compliance",
            body: "Designed with GDPR and SOC 2 principles; data residency honored where configured.",
          },
        ].map((item) => (
          <div key={item.title} className="space-y-2">
            <h2 className="text-xl font-semibold text-white">{item.title}</h2>
            <p className="text-gray-300 text-sm leading-relaxed">{item.body}</p>
          </div>
        ))}
      </div>

      <div className="bg-gradient-to-r from-gray-900 to-blue-900/30 border border-white/10 rounded-2xl p-6 text-center space-y-3">
        <h3 className="text-xl font-bold">Security questions?</h3>
        <p className="text-gray-400 text-sm">
          Reach us at info@qryptshield.com. We can share our security practices
          and architecture details under NDA if needed.
        </p>
      </div>
    </div>
  </div>
);

export default Security;
